
// src/web/components/left-sidebar-user.jsx

import React from 'react'
import { translate } from 'react-i18next'
import _ from 'lodash'
import {
  List,
  ListItem,
} from 'react-toolbox/lib/list'
import leftSidebarUserTheme from './themes/left-sidebar-user.css'

function LeftSideBarUser(props) {
  const {
    t,
    user,
    openUserSettingsPage
  } = props

  return (
    <List theme={leftSidebarUserTheme}>
      <ListItem selectable
          theme={leftSidebarUserTheme}
          avatar={user && user.icon_image.thumb_url}
          caption={user && user.name || ''}
          leftIcon={!user && "account_circle" || ''}
          onClick={openUserSettingsPage} />
    </List>
  )
}

export default translate()(LeftSideBarUser)



// WEBPACK FOOTER //
// ./src/web/components/left-sidebar-user.jsx